import { Preferences } from '@capacitor/preferences';

export async function clear(): Promise<void> {
  await Preferences.clear();
}

export async function set(key: string, value: any): Promise<void> {
  await Preferences.set({
    key: key,
    value: JSON.stringify(value || []),
  });
}

export async function get(key: string): Promise<any> {
  const item = await Preferences.get({ key: key });

  let value;
  try {
    value = JSON.parse(item.value as any);
  } catch (e) {
    value = item.value as any;
  }
  console.log('Loading Data in Preferences helper', key);
  // console.log("Getting Data " + value);
  return value as any;
}

export async function remove(key: string): Promise<void> {
  console.log('Remove Key', key);
  await Preferences.remove({
    key: key,
  });
}
